export class RealEstate {
    constructor(model, parameters = []) {
        this.id = model.id;
        this.image = model.image;
        this.price = model.price;
        this.area = model.area;
        this.url = model.url;
        this.lng = model.lng;
        this.lat = model.lat;
        this.src = model.src;
        this.areaPrice = this.price / this.area;
        this.active = true;

        this.corrections = [];
        for (let parameter of parameters) {
            this.corrections.push({ name: parameter, value: 0 });
        }
    }

    correctionValues() {
        return this.corrections.map(x => x.value);
    }

    calculateCorrectionValue() {
        let values = this.correctionValues();
        return sum(values) / values.length;
    }
}
